module.exports = __webpack_public_path__ + "img/mapa.35ec98e0.svg";